import { Dialog, DialogActions, DialogContent, Typography } from '@mui/material';
import PaiButton from 'features/ui/base-components/pai-button';
import PaiLink from 'features/ui/base-components/pai-link';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import PaiTextField from '../../ui/base-components/pai-text-field';

interface Props {
  open: boolean;
  profileName: string;
  nameTakenError: boolean | undefined;
  loading: boolean;

  handleGlobalProfileNameChange(event: React.ChangeEvent<HTMLInputElement>): void;

  handleClose(): void;

  handleCreateNewGlobalProfile(): void;
}

const CreateGlobalProfileDialog: React.FC<Props> = ({
  open,
  profileName,
  nameTakenError,
  loading,
  handleGlobalProfileNameChange,
  handleClose,
  handleCreateNewGlobalProfile,
}) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog open={open} classes={{ paper: classes.paper }} fullWidth={true} maxWidth={'xs'}>
      <DialogContent className={classes.content}>
        <PaiTextField value={profileName} placeholder={t('enterPersonaName')} onChange={handleGlobalProfileNameChange} />
        {nameTakenError ? <Typography className={classes.errorText}>{t('nameAlreadyTakenError')}</Typography> : null}
        <Typography className={classes.paragraph}>
          <Trans i18nKey={'confirmSaveGlobalProfile'} values={{ profileName: profileName }}>
            Die ausgewählten Projekte werden als globales Profil unter dem Namen <strong>{profileName}</strong> gespeichert.\n\nDas ist eine
            Adminfunktion und kann nur schwer im Nachgang korrigiert werden.
          </Trans>
        </Typography>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <PaiLink text={t('cancel')} size={'sm'} underline={'always'} action={handleClose} />
        <PaiButton text={t('accept')} disabled={profileName.trim() === '' || loading} action={handleCreateNewGlobalProfile} />
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: 0,
  },
  content: {
    paddingBottom: '12px',
  },
  paragraph: {
    fontSize: theme.typography.pxToRem(12),
    padding: '0 4px',
    marginTop: '16px',
  },
  errorText: {
    fontSize: theme.typography.pxToRem(11),
    color: theme.palette.error.main,
    marginTop: '4px',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '16px',
    padding: '0 24px 20px 24px',
  },
}));

export default CreateGlobalProfileDialog;
